/** Digits for wa.me — prefers India country code for 10-digit numbers. */
export function normalizeWhatsAppPhoneDigits(phone: string): string | null {
  const digits = phone.replace(/\D/g, "");
  if (!digits) {
    return null;
  }
  if (digits.length === 10) {
    return `91${digits}`;
  }
  if (digits.length === 12 && digits.startsWith("91")) {
    return digits;
  }
  if (digits.length === 11 && digits.startsWith("0")) {
    return `91${digits.slice(1)}`;
  }
  return digits;
}

export function toWhatsAppChatHref(phone: string, text?: string): string | null {
  const digits = normalizeWhatsAppPhoneDigits(phone);
  if (!digits) {
    return null;
  }

  const base = `https://wa.me/${digits}`;
  const trimmedText = text?.trim();
  return trimmedText ? `${base}?text=${encodeURIComponent(trimmedText)}` : base;
}

/** Normalize tenant runtime config bot phone for miqaat check-in posters. */
export function resolveMiqaatBotWhatsappPhone(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) {
    return null;
  }
  return normalizeWhatsAppPhoneDigits(trimmed);
}

/**
 * Pre-filled compose text so scanning the poster QR needs just one tap (Send) to reach the
 * bot's check-in flow — WhatsApp never auto-sends from a wa.me link, only pre-fills the box.
 */
export const MIQAAT_CHECKIN_QR_PREFILL_TEXT = "check in";

/** Same bot chat URL for every venue poster (no per-venue payload), pre-filled to start check-in. */
export function buildMiqaatBotChatQrValue(phone: string | null | undefined): string | null {
  if (!phone) {
    return null;
  }
  return toWhatsAppChatHref(phone, MIQAAT_CHECKIN_QR_PREFILL_TEXT);
}
